import { Routes } from '@angular/router';
import { FlowRoute, noIndexGuard } from '@tnq/flows/shared';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: FlowRoute.Onboarding,
  },
  {
    path: 'auto',
    pathMatch: 'full',
    redirectTo: FlowRoute.VehicleOnboarding,
  },
  {
    path: 'brandstof',
    pathMatch: 'full',
    redirectTo: FlowRoute.VehicleOnboarding,
  },
  {
    path: 'upsell',
    pathMatch: 'full',
    redirectTo: FlowRoute.UpsellEnergy,
  },

  {
    path: FlowRoute.Onboarding,
    loadChildren: () =>
      import('@tnq/flows/onboarding').then((c) => c.onboardingRoutes),
  },
  {
    path: FlowRoute.UpsellEnergy,
    loadChildren: () => import('@tnq/flows/upsell').then((c) => c.upsellRoutes),
  },
  {
    // Universal link target the native apps intercept to hand off back to
    // the app; only rendered when that interception fails. Sibling to
    // FlowRoute.UpsellEnergy, not a child of it — the native teams settled
    // on this as a flow-agnostic path.
    path: FlowRoute.UpsellReturnToApp,
    canActivate: [noIndexGuard()],
    loadComponent: () =>
      import('@tnq/flows/upsell').then((c) => c.UpsellReturnToAppComponent),
  },
  {
    path: 'auth/password-reset',
    loadComponent: () =>
      import('../mobile-apps').then((c) => c.PasswordResetComponent),
  },
  {
    path: 'email/confirm',
    loadComponent: () =>
      import('../mobile-apps').then((c) => c.EmailConfirmationComponent),
  },
];
